import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import * as yup from "yup";
import IconButton from "@mui/material/IconButton";
import MapIcon from "@mui/icons-material/Map";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Box from "@mui/material/Box";
import { AppContext } from "../context/AppContextProvider";
import HaqtSelect from "./HaqtSelect/HaqtSelect";
import { getTenantsData } from "../services/TenantServices";
import { useFormik } from "formik";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../utils/sessionStorageUtils";
import HaqtButton from "./HaqtButton/HaqtButton";
import "./haqttenanttoggle.scss";

const HaqtTenantToggle = () => {
  const [anchorTenantEl, setAnchorTenantEl] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedSites, setSelectedSites] = useState([]); 
  const [tenantNames, setTenantNames] = useState([]);
  const [siteNames, setSiteNames] = useState([]);

  const selectedSitesData =getSessionStorageItem("haqt-selected-system")|| [];//modified for wosh
  const navigate = useNavigate();
  const deviceStatusUrl = window.location.pathname;

  const validationSchema = yup.object({
    tenant: yup.string().required("Tenant is required"),
    site: yup.array().min(1, "At least one site must be selected"), // Updated to handle array validation
  });


const formik = useFormik({
  initialValues: {
    tenant: "",
    site: [], // Storing an array for multiple selected sites
  },
  validationSchema: validationSchema,
  onSubmit: async () => {
const selectedSitesArray = selectedSites;

// Prepare an array to store all selected tenant, site, and system data
const tenantSiteSystemDataToStore = [];


// Loop through the selected sites to find their corresponding tenant, site, and system
selectedSitesArray.forEach((selectedSiteName) => {
  tenantData?.data?.tenants.forEach((tenant) => {
    // Check if the site exists in the tenant's list of sites
    const foundSite = tenant.sites.find(
      (site) => site.siteName === selectedSiteName
    );

    // If a site is found, store its tenant, site, and system information
    if (foundSite) {
      // Loop through the systems of the found site
      foundSite.systems?.forEach((system) => {
        tenantSiteSystemDataToStore.push({
          tenant: {
            id: tenant?.tenantId, // Assuming 'tenantId' is the correct key for tenant ID
            name: tenant?.tenantName, // Assuming 'tenantName' is the correct key for tenant name
          },
          site: {
            id: foundSite?.siteId, // Assuming 'siteId' is the correct key for site ID
            name: foundSite?.siteName, // Assuming 'siteName' is the correct key for site name
          },
          system: {
            id: system?.systemId, // Assuming 'systemId' is the correct key for system ID
            name: system?.systemName, // Assuming 'systemName' is the correct key for system name
          },
        });
      });
    }
  });
});

const uniqueTenantSiteSystemData = tenantSiteSystemDataToStore.reduce((acc, { tenant, site, system }) => {
  // Find the tenant entry
  let tenantEntry = acc.find(t => t.id === tenant.id);
  
  if (!tenantEntry) {
    // Create a new tenant entry if it doesn't exist
    tenantEntry = { ...tenant, sites: [] };
    acc.push(tenantEntry);
  }
  
  // Find the site entry under the tenant
  let siteEntry = tenantEntry.sites.find(s => s.id === site.id);
  
  if (!siteEntry) {
    // Create a new site entry if it doesn't exist
    siteEntry = { ...site, systems: [] };
    tenantEntry.sites.push(siteEntry);
  }
  
  // Add the system to the site's systems
  siteEntry.systems.push(system);
  
  return acc;
}, []);

// Adjust the final output to remove "tenant": { and "site": {
const finalOutput = {
  tenants: uniqueTenantSiteSystemData.map(tenantData => ({
    id: tenantData.id,
    name: tenantData.name,
    sites: tenantData.sites.map(siteData => ({
      id: siteData.id,
      name: siteData.name,
      systems: siteData.systems
    }))
  }))
};


    // Now store the unique tenant-site-system data in session storage
    setSessionStorageItem("haqt-selected-system", finalOutput);
    
    // Update tenant data state or perform any additional logic if needed
    setTenantData((prevState) => ({
      ...prevState,
      isInitialLoad: false,
      
    }));
    setShowTenantToggle(false);

   navigate(0);
  },
});

  const {
    tenantData,
    setTenantData,
    showTenantToggle,
    setShowTenantToggle,
    isAdminUser,
    setShowSpinner,
  } = useContext(AppContext);

  //to get dropdown values from the array data
  const getValuesForDropDown = (dataArray, dataType) => {
    return dataArray?.map((item) => {
      return { id: item[dataType + "Id"], label: item[dataType + "Name"] };
    });
  };

  //on initial load set the dropdown data
  const setDropdownData = (data) => {
    if (data?.tenants && Array.isArray(data.tenants)) {
      const tenants = getValuesForDropDown(data.tenants, "tenant");
      setTenantNames(tenants);
    if (data.tenants.length === 1) {
      const sites = getValuesForDropDown(data?.tenants[0]?.sites, "site");
      setSiteNames(sites);
      setSelectedTenant(tenants[0]);
      formik.setFieldValue("tenant", tenants[0]?.label);
      if (sites.length >= 1) {
        const siteNamesArray = selectedSitesData.tenants[0].sites.map(site => site.name);
        const combinedSiteNames = siteNamesArray.join("_ "); // Combine names with a comma
        formik.setFieldValue("site",combinedSiteNames);
        setSelectedSite(combinedSiteNames);
        setShowTenantToggle(true);
      } else {
        console.error("selectedSitesData or sites not available");
      }
    }else {
      console.error("data.tenants is either null or not an array");
    }
  }
  else {
    // If there are multiple tenants, you migHaqt want to handle
    // setting initial site and system names here or just leave them empty
    setSiteNames([]); // Reset the site names
    setSelectedSites([]);
  }
  };

  const fetchData = async () => {
    try {
      const response = await getTenantsData();
      if (response.data.tenants) {
        setDropdownData(response.data);
      }
      setResponseData(response.data);
      setTenantData((prevState) => ({
        ...prevState,
        isInitialLoad: false,
        data: response.data,
      }));
      if (!response.data || response.data.length === 0) {
       
        setShowTenantToggle(false);
        return;
      }
    } catch (error) {
      if (error?.response?.data?.message === "NotFound") {
        setShowTenantToggle(false);
        setTenantData(prevState => ({
          ...prevState,
          data: {},
          isInitialLoad: false,
        }));
        sessionStorage.removeItem('haqt-selected-system');
        return;
      }
    }
  };

  useEffect(() => {
    //If its initial load then take data from API else takes the data from context
    if (tenantData?.isInitialLoad) {

      fetchData();
      setTenantData(prevState => ({
        ...prevState,
        isInitialLoad: false,
      }));
    } else {
      if (tenantData?.data?.tenants) {
        setDropdownData(tenantData.data);
        if (JSON.stringify(selectedSitesData) !== "{}") {
          const tenantName = selectedSitesData.tenants[0].name;
          const siteNamesArray = selectedSitesData.tenants[0].sites.map(site => site.name);
          const combinedSiteNames = siteNamesArray.join("_ "); // Combine names with a comma
          formik.setFieldValue("tenant", tenantName);
          formik.setFieldValue("site",combinedSiteNames);
          const selectedTenant = tenantData?.data?.tenants.find(
            (tenant) => tenant.tenantName === tenantName,
          );
          if (tenantName !== selectedTenant?.tenantName) {
            navigate("/admin/maps");
            return;
          }
          const sites = getValuesForDropDown(selectedTenant?.sites, "site");
          setSiteNames(sites);
        }
      }
    }
  }, []);

  const handleChangeTenant = (e) => { 
    // Check if there's only one tenant available
  if (tenantData?.data?.tenants.length === 1) {
    const selectedTenant = tenantData.data.tenants[0]; // Automatically select the only tenant
    formik.setFieldValue("tenant", selectedTenant.label);
    setSelectedTenant(selectedTenant);
  } else {
    const selectedTenant = tenantData?.data?.tenants.find(
      (tenant) => tenant.tenantName === e.label,
    );
  }
    if (selectedTenant) {
      // Get the list of sites for the selected tenant
      const sites = getValuesForDropDown(selectedTenant?.sites, "site");
      setSiteNames(sites);
      // Check if there is only one site
      if (sites.length === 1) {
        // Automatically select the site if there's only one
        formik.setFieldValue("site", sites[0].label);
        setSelectedSite(sites[0]);
      } else {
        // If there are multiple sites, clear the system and site selections
        const siteNamesArray = selectedSitesData.tenants[0].sites.map(site => site.name);
        const combinedSiteNames = siteNamesArray.join("_ "); // Combine names with a comma
        formik.setFieldValue("site",combinedSiteNames);
        setSelectedSite(combinedSiteNames);
      }
  
      // Set the selected tenant after handling sites
      setSelectedTenant(selectedTenant);
    }
  };
  

  const handleChangeSites = (siteLabel) => {
    const selectedTenantName = formik?.values?.tenant;
    const selectedTenant = tenantData?.data?.tenants.find(
      (item) => item.tenantName === selectedTenantName,
    );
    if (!selectedTenant) {
      return;
    }
  
    const selectedSite = selectedTenant?.sites?.find((site) => site.siteName === siteLabel);
  
    if (!selectedSite) {
      return;
    }
  
    // If the site is already selected, remove it; otherwise, add it
    let newSelectedSites = [...selectedSites];
    const isSelected = selectedSites.includes(siteLabel);
  
    if (isSelected) {
      // Remove site from selectedSites
      newSelectedSites = selectedSites.filter((site) => site !== siteLabel);
    } else {
      // Add site to selectedSites
      newSelectedSites.push(siteLabel);
    }
    setSelectedSites(newSelectedSites); // Update selected sites
    formik.setFieldValue("site", newSelectedSites); // Update formik's site field
  };
 
  const toggleHaqtTenantToggle = (event) => {
     setAnchorTenantEl(event.currentTarget);
  };

  const handleCloseTenantToggle = () => {
    setAnchorTenantEl(null);
  };

  return (
    <>
    <div style={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}>
    <div
      style={{
       // display: tenantData?.data?.tenants?.length > 1 ? "flex" : "none",
       display: tenantData?.data?.tenants?.some(tenant => tenant.sites.length > 0) ? "flex" : "none",
        alignItems: 'center',
        flexDirection: 'row',
        paddingRigHaqt: 0,
        marginLeft: "8px",
      }}
      onClick={toggleHaqtTenantToggle}
    >
      <IconButton
        title="Toggle System"
        aria-label="Toggle System"
        onClick={(e) => setAnchorTenantEl(e.currentTarget)}
        edge="start"
        sx={{ color: "#fff", marginTop: "-4px" }}
      >
        <HomeWorkOutlinedIcon style={{ color: '#0A6073', fontSize: "24px", padding: "0px" }} />
      </IconButton>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          cursor: "pointer"
        }}
        onClick={toggleHaqtTenantToggle}
      >
        <Typography
          variant="body1"
          noWrap
          component="div"
          sx={{
            alignItems: "center",
            pr: 1,
            color: '#0A6073',
            fontWeigHaqt: "bold",
            fontSize: "12px",
            display: { xs: "none", md: "flex" },
          }}
        >
           {selectedSitesData?.tenants?.[0]?.name || 'No Tenant Selected'}
        </Typography>
        <Typography
          variant="body1"
          noWrap
          component="div"
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            pr: 1,
            color: '#0A6073',
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
            fontSize: "10px",
          }}
        >
          {selectedSite}

        </Typography>
      </div>
      <div>
        {JSON.stringify(selectedSitesData) !== "{}" && (
          <IconButton
            size="small"
            sx={{
              display: { xs: "none", md: "flex" },
              marginLeft: "-7px",
              marginTop: "-17px",
              fontWeigHaqt: "bold",
              color: '#0A6073',
              "&:hover": {
                background: "none",
              },
            }}
          >
            <ArrowDropDownIcon />
          </IconButton>
        )}
      </div>
    </div>
  </div>

  {showTenantToggle && (
    <Popover
      open={Boolean(anchorTenantEl)}
      anchorEl={anchorTenantEl}
      onClose={handleCloseTenantToggle}
      className="tenant-toggle-container"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}

    >

      <Box sx={{ width: '100%', padding: 2, paddingTop: 3 }}>
        <form onSubmit={formik.handleSubmit} className="form">
          {tenantNames?.length > 0 && (
            <HaqtSelect
              hideClearIndicator={true}
              fullWidth
              labelId="select-tenant-label"
              name="tenant"
              label="Tenant"
              value={selectedTenant || formik.values.tenant}
              onBlur={formik.handleBlur}
              error={formik.touched.tenant && Boolean(formik.errors.tenant)}
              helperText={formik.touched.tenant && formik.errors.tenant}
              onChange={(event, selectedOption) => {
                handleChangeTenant(selectedOption);
                formik.setFieldValue("tenant", selectedOption.label);
                setSelectedTenant(selectedOption);
              }}
              disabled={false}
             // options={tenantNames || []}
            />
          )}
          {siteNames.length > 0 && (
            <div>
              <Typography variant="subtitle1" sx={{ color: 'black' }}>Select Sites:</Typography>
              {siteNames.map((site) => (
                <div key={site.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                  <input
                    type="checkbox"
                    checked={selectedSites.includes(site.label)}
                    onChange={() => handleChangeSites(site.label)}
                  />
                  <label style={{ marginLeft: '8px', color: 'black' }}>{site.label}</label>
                </div>
              ))}
            </div>
          )}
          
          <div className="buttons-container">
            <HaqtButton
              variant="outlined"
              className="button-element"
              type="submit"
              style={{
                background: "#005572",
                color: "white",
                textTransform: "capitalize",
                fontFamily: "Helvetica-Normal",
              }}
              buttonName={"Ok"}
            />
            <HaqtButton
              variant="outlined"
              onClick={() => handleCloseTenantToggle()}
              style={{
                background: "#005572",
                color: "white",
                textTransform: "capitalize",
                fontFamily: "Helvetica-Normal",
              }}
              buttonName={"Cancel"}
            />
          </div>
        </form>
      </Box>
    </Popover>
  )}
</>
);
};
export default HaqtTenantToggle;